/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import "./Nav.css";
import {
  Col,
  Container,
  Dropdown,
  Offcanvas,
  Row,
} from "react-bootstrap";
import { AiOutlineMenu } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { sidebarItems } from "./SidebarData";
import DeleteModel from "../../../components/DeleteModel";
import logo from "../../../assets/images/logo.jpg";
import { Menu } from "antd";
import { clearAllLocalStorage } from "../../../constants/localStorage";
import { primaryColor } from "../../../constants/colors";
import { app_Name } from "../../../constants/helpers";
import { FaUserCircle } from "react-icons/fa";
const { SubMenu } = Menu;
const MainNav = () => {
  const { color } = "#ffffff";
  const [show, setShow] = useState(false);
  const [logoutShow, setLogoutShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClose = () => setShow(false);
  const handleNavigateAddForm = () => setShow(true);
  const handleModelClose = () => setLogoutShow(false);

  const handleLogout = () => {
    clearAllLocalStorage();
    navigate("/");
    window.location.reload();
  };
  const findSelectedKey = (items, path) => {
    for (const item of items) {
      if (item.url === path) {
        return item.id;
      }
      if (item.children) {
        const childKey = findSelectedKey(item.children, path);
        if (childKey) {
          return childKey;
        }
      }
    }
    return null;
  };

  const selectedKey = findSelectedKey(sidebarItems, location.pathname);
  return (
    <>
      <Container
        fluid
        className="d-flex flex-row flex-wrap-wrap justify-content-between align-items-center overflowX-hidden"
        style={{
          position: "sticky",
          top: "0",
          zIndex: 1000,
          backgroundColor: "#ffffff",
          borderBottom: "2px solid #e9edf4",
        }}
      >
        <Row className="d-flex flex-row flex-wrap-wrap justify-content-around align-items-center p-2">
          <Col className="d-lg-none d-xl-none d-sm-flex">
            <AiOutlineMenu
              size={25}
              onClick={handleNavigateAddForm}
              className="pointer"
              color="#515b73"
            />
          </Col>
          <Col
            className="d-lg-flex d-none d-sm-none flex-row flex-wrap-wrap justify-content-between align-items-center"
            style={{ marginRight: "100px" }}
          >
            <img
              src={logo}
              width={45}
              className="pointer rounded-circle"
              alt="MainLogoImage1"
              title="MainLogoImage1"
            />
          </Col>
        </Row>
        {/* mobile view */}

        <Row>
          <Col className='d-lg-none d-sm-flex flex-row flex-wrap-wrap justify-content-between" align-items-center'>
            <img
              src={logo}
              width={50}
              className="p-2 pointer rounded-circle"
              alt="MainLogoImage2"
              title="MainLogoImage2"
            />
          </Col>
        </Row>

        <Row className="d-flex mt-1">
          <Col className="d-lg-none d-sm-flex">
            <div className="d-flex align-items-center position-relative">


              <Dropdown>
                <Dropdown.Toggle
                  className="mobile-view-dropdown"
                  id="dropdown-basic"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "#515b73",
                  }}
                >
                  <BsThreeDotsVertical
                    size={25}
                    style={{ cursor: "pointer", color: "#515b73" }}
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item></Dropdown.Item>
                  <Dropdown.Item onClick={() => setLogoutShow(true)}>
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>

          {/* lap view */}
          <Col className="d-lg-flex d-none d-sm-none flex-row flex-wrap-wrap justify-content-center align-items-center position-relative">
            <div className="d-flex align-items-center position-relative">


              <Dropdown>
                <Dropdown.Toggle
                  id="dropdown-basic"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "#515b73",
                    padding: 0,
                  }}
                >
                  <FaUserCircle size={30} />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setLogoutShow(true)}>
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Conditionally render Offcanvas for large screens */}
      <Row className="d-none d-lg-flex d-xl-flex d-xxl-flex">
        <Offcanvas scroll={false} show={show} onHide={handleClose}>
          <Offcanvas.Header style={{ backgroundColor: color }} closeButton>
            <Offcanvas.Title
              className="custom-title"
              style={{
                fontSize: "16px",
                color: "#515b73",
              }}
            >
              <img
                src={logo}
                width={50}
                className="rounded-circle p-2 rounded-circle"
                alt="image"
              />
              {app_Name}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body style={{ backgroundColor: " #FFFFFF" }}>
            <Menu
              mode="inline"
              selectedKeys={[selectedKey]}
              style={{ height: "100%", borderRight: 0 }}
              theme="light"
            >
              {sidebarItems.map((menu) =>
                menu.children && menu.children.length > 0 ? (
                  <SubMenu
                    key={menu.id}
                    icon={menu.icon}
                    style={{
                      color: selectedKey === menu.id ? primaryColor : "#6d758a",
                      backgroundColor:
                        selectedKey === menu.id ? "#ADD8E6" : "#ffffff",
                    }}
                    title={
                      <span style={{ color: "#6d758a" }}>{menu.label}</span>
                    }
                  >
                    {menu.children.map((item) => (
                      <Menu.Item
                        key={item.id}
                        icon={item.icon}
                        style={{
                          color:
                            selectedKey === item.id ? primaryColor : "#6d758a",
                          backgroundColor:
                            selectedKey === item.id ? "#ADD8E6" : "#ffffff",
                        }}
                      >
                        <Link
                          onClick={handleClose}
                          className="link-unstyled"
                          to={item.url}
                        >
                          {item.label}
                        </Link>
                      </Menu.Item>
                    ))}
                  </SubMenu>
                ) : (
                  <Menu.Item
                    key={menu.id}
                    icon={menu.icon}
                    style={{
                      color: selectedKey === menu.id ? primaryColor : "#6d758a",
                      backgroundColor:
                        selectedKey === menu.id ? "#ADD8E6" : "#ffffff",
                    }}
                  >
                    <Link
                      onClick={handleClose}
                      className="link-unstyled"
                      to={menu.url}
                    >
                      {menu.label}
                    </Link>
                  </Menu.Item>
                )
              )}
            </Menu>
          </Offcanvas.Body>
        </Offcanvas>
      </Row>

      <DeleteModel
        DELETESTATE={logoutShow}
        ONCLICK={handleModelClose}
        YES={handleLogout}
        DESCRIPTION="Do You Want To Logout"
        DELETETITLE="Logout"
      />

    </>
  );
};

export default MainNav;